<script lang="ts">
	import type { Snippet } from "svelte";
	import { heroDefaults, type HeroBaseProps, type HeroBadge, type HeroCta } from "./hero.types";

	type HeroBaseComponentProps = HeroBaseProps & {
		children: Snippet<
			[
				{
					title: string;
					subtitle?: string;
					badge?: HeroBadge;
					cta?: HeroCta;
					secondaryCta?: HeroCta;
				}
			]
		>;
	};

	let {
		title = heroDefaults.title,
		subtitle = heroDefaults.subtitle,
		badge,
		cta,
		secondaryCta,
		children
	}: HeroBaseComponentProps = $props();
</script>

{@render children({ title, subtitle, badge, cta, secondaryCta })}
